export enum ApiAppSettingsValueType {
  Boolean = 'Boolean',
  Int = 'Int',
  Double = 'Double',
  Decimal = 'Decimal',
  String = 'String',
  JsonObject = 'JsonObject',
  JsonList = 'JsonList',
  CommaDelimitedList = 'CommaDelimitedList',
}

export interface ApiAppSettingsModel {
  guid: string;
  name: string;
  valueType: ApiAppSettingsValueType;
  value: string;
}
